// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-icon-container {
  margin: 0;
  background-color: transparent;
}

.notification-icon {
  color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/app/view/control/notification-icon/notification-icon.component.scss"],"names":[],"mappings":"AAAA;EACI,SAAA;EACA,6BAAA;AACJ;;AACA;EACI,kBAAA;AAEJ","sourcesContent":[".notification-icon-container {\n    margin: 0;\n    background-color: transparent;\n}\n.notification-icon {\n    color: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
